import { render, staticRenderFns } from "./UpdateUsers.vue?vue&type=template&id=4136b4b7&scoped=true&"
import script from "./UpdateUsers.vue?vue&type=script&lang=js&"
export * from "./UpdateUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136b4b7",
  null
  
)

export default component.exports